import { useContext } from "react";
import { PageContext } from "context/Page";

export const usePageContext = () => {
  return useContext(PageContext);
};
